import HomeFeatured from './HomeFeatured';

export default HomeFeatured;